import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import { AppState } from '../app.service';
import { CONFIG } from './api.config';

@Injectable()
export class ApiService {
  private host: string;

  constructor(
    private http: HttpClient,
    private appState: AppState
  ) {
    this.host = CONFIG.host[this.appState.get('env')];
  }

  public get(uri: string, options?: any): Observable<any> {
    return this.http.get(this.host + '/' + uri, options);
  }

  public delete(uri: string, options?: any): Observable<any> {
    return this.http.delete(this.host + '/' + uri, options);
  }

  public post(uri: string, data: any, options?: any): Observable<any> {
    return this.http.post(this.host + '/' + uri, data, options);
  }

  public put(uri: string, data: any, options?: any): Observable<any> {
    return this.http.put(this.host + '/' + uri, data, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/api/api.service.ts